import { useState } from "react";
import SurveyIngestion from "@solimat/solimat-web-endpoint/lib/survey-ingestion";

const useGetSurveyJsonBySurveyBySurvey = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_ENCUESTAS_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_ENCUESTAS_KEY || "";
  const apiSurvey = new SurveyIngestion.SurveyIngestionService(BASE_URL, FUNCTIONS_KEY);

  const [loadingGetSurveyJsonBySurvey, setLoadingGetSurveyJsonBySurvey] = useState(false);
  const [successGetSurveyJsonBySurvey, setSuccessGetSurveyJsonBySurvey] = useState(false);
  const [errorGetSurveyJsonBySurvey, setErrorGetSurveyJsonBySurvey] = useState(null);
  const [surveyJsonBySurvey, setSurveyJsonBySurvey] = useState<null|any>(null);

  const getSurveyJsonBySurvey = (surveyId:string,_cb?:(data:any)=>void) => {
    setLoadingGetSurveyJsonBySurvey(true);
    setErrorGetSurveyJsonBySurvey(null);
    apiSurvey
      .getSurveyJsonBySurvey(surveyId)
      .then((res: any) => {
        setSuccessGetSurveyJsonBySurvey(true);
        setLoadingGetSurveyJsonBySurvey(false);
        setSurveyJsonBySurvey(res.data)
        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err:any) => {
        console.error("getSurveyJsonBySurvey error: ", err);
        setErrorGetSurveyJsonBySurvey(err);
        setLoadingGetSurveyJsonBySurvey(false);
      });
  };

  return {
    surveyJsonBySurvey,
    getSurveyJsonBySurvey,
    successGetSurveyJsonBySurvey,
    loadingGetSurveyJsonBySurvey,
    errorGetSurveyJsonBySurvey
  };
};

export default useGetSurveyJsonBySurveyBySurvey;
